import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/", icon: "ri-home-4-line" },
  { label: "漫画大全", to: "/category/all", icon: "ri-book-2-line" },
  { label: "人气榜单", to: "/#ranking", icon: "ri-trophy-line" },
  { label: "关于我们", to: "/about", icon: "ri-information-line" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (to: string) => {
    if (to.startsWith("/#")) return false;
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const kw = keyword.trim();
    setMobileOpen(false);
    navigate(kw ? `/category/all?q=${encodeURIComponent(kw)}` : "/category/all");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="43423漫画网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-comic text-lg text-background-50">
            漫
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-comic text-xl font-bold text-foreground-950">43423漫画网</span>
            <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-600">免费漫画 · 每日更新</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-bold transition-colors ${
                isActive(item.to)
                  ? "bg-primary-50 text-primary-600"
                  : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden items-center md:flex" role="search">
          <div className="flex items-center overflow-hidden rounded-full border border-background-200 bg-background-100 focus-within:border-primary-400">
            <i className="ri-search-line pl-3.5 text-sm text-foreground-500"></i>
            <input
              type="search"
              name="q"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画名称"
              aria-label="搜索漫画"
              className="w-44 bg-transparent px-2.5 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none lg:w-52"
            />
            <button
              type="submit"
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm text-background-50 transition-colors hover:bg-primary-600"
              aria-label="搜索"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </form>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-lg text-foreground-700 md:hidden"
          aria-label={mobileOpen ? "关闭菜单" : "打开菜单"}
        >
          <i className={mobileOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <form onSubmit={handleSearch} className="mb-3 flex items-center overflow-hidden rounded-full border border-background-200 bg-background-100">
            <i className="ri-search-line pl-3.5 text-sm text-foreground-500"></i>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画名称"
              aria-label="搜索漫画"
              className="w-full bg-transparent px-2.5 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button type="submit" className="flex h-8 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm text-background-50">
              <i className="ri-search-line"></i>
            </button>
          </form>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className={`flex items-center gap-2.5 rounded-md px-3 py-2.5 text-sm font-bold transition-colors ${
                  isActive(item.to) ? "bg-primary-50 text-primary-600" : "text-foreground-700"
                }`}
              >
                <i className={`${item.icon} text-base`}></i>
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}